import { render, staticRenderFns } from "./AnswerTopic.vue?vue&type=template&id=9b85eb60&scoped=true"
import script from "./AnswerTopic.vue?vue&type=script&lang=js"
export * from "./AnswerTopic.vue?vue&type=script&lang=js"
import style0 from "./AnswerTopic.vue?vue&type=style&index=0&id=9b85eb60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b85eb60",
  null
  
)

export default component.exports